import React from "react";
import { unwrap, map, some, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { Account_$reflection, SearchInput_$reflection, SearchInput } from "../Shared/ApiDataTypes.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { obj_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { corsProps } from "../Promises.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { comparePrimitives, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { sortBy } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { createDisposable } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TextField, Autocomplete } from "@mui/material";
import { Account_tryGetNameStr } from "../Utils.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";

export function Components_UserSearchBar_25368B8A(components_UserSearchBar_25368B8AInputProps) {
    const ptgOnly = components_UserSearchBar_25368B8AInputProps.ptgOnly;
    const onSelect = components_UserSearchBar_25368B8AInputProps.onSelect;
    const ptgOnly_1 = defaultArg(ptgOnly, false);
    const patternInput = reactApi.useState(false);
    const setOpen = patternInput[1];
    const isOpen = patternInput[0];
    const patternInput_1 = reactApi.useState([]);
    const accounts = patternInput_1[0];
    const loading = isOpen && (accounts.length === 0);
    useEffectWithDeps(() => {
        let properties_2;
        let active = true;
        if (loading) {
            let pr_1;
            const item = new SearchInput("");
            const body = Auto_generateBoxedEncoder_437914C6(SearchInput_$reflection(), undefined, undefined, undefined)(item);
            const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Account_$reflection()), undefined, undefined);
            const data_1 = some(body);
            const caseStrategy_3 = undefined;
            const extra_3 = undefined;
            try {
                const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(`${"/api/account/search"}?ptgonly=${ptgOnly_1}`, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Account_$reflection()), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_1.then((res) => {
                if (active) {
                    if (res.tag === 1) {
                        console.error(some("[UserSearchBar] Error searching for users"), res.fields[0]);
                    }
                    else {
                        patternInput_1[1](sortBy((account) => {
                            if (!isNullOrWhiteSpace(account.FirstName)) {
                                return account.FirstName.toLocaleLowerCase();
                            }
                            else {
                                return account.Email.toLocaleLowerCase();
                            }
                        }, res.fields[0], {
                            Compare: comparePrimitives,
                        }));
                    }
                }
                else {
                    console.debug("[UserSearchBar] Searched while not active");
                }
            });
        }
        return createDisposable(() => {
            active = false;
        });
    }, [loading]);
    return MuiHelpers_createElement(Autocomplete, [["fullWidth", false], ["size", "small"], ["open", isOpen], ["onOpen", (ev) => {
        setOpen(true);
    }], ["onClose", (ev_1) => {
        setOpen(false);
    }], ["options", Array.from(accounts)], ["getOptionLabel", Account_tryGetNameStr], ["onChange", (_arg_2, v, _arg_1_2) => {
        onSelect(v);
    }], ["renderInput", (parameters) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(parameters), delay(() => singleton(["label", "Velg bruker"]))))))]]);
}

